import TKStock from '@tk/components/tk.stock';
import { LoadingType, StockData } from './tk.article.list';
import isBase64 from '@tk/utilities/tk.base64';
import { fetchRequest, setAsyncUrl } from '@tk/utilities/tk.fetch';

interface ResponseItem {
    catitemboid: string;
    catitemartinternalno: string;
    sort: string;
    template: string;
    basispriceisset: boolean;
    promopriceisset: boolean;
    servicepriceisset: boolean;
    loadingtype: LoadingType;
    html?: string;
    nextReceipt?: string;
}

// Loadingtype
// 1: Normal
// 2: Über Artikelliste

export default class DIWStock extends TKStock {
    constructor() {
        super();
    }

    connectedCallback(): void {
        const item: StockData = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this,
        };
        if (this.articleList && (!this.isAsyncTile || this.loadingType === '2')) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }

    handleStock(item: StockData) {
        const items =
            this.asyncURL === setAsyncUrl(true)
                ? TKStock.getItemsAsJSONString([item])
                : TKStock.getItemsAsEntrypoint([item]);

        const data = {
            type: 'stock',
            arttype: 'single',
            ...items,
        };

        fetchRequest({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this),
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    refreshStock(item: StockData, responseItem: ResponseItem) {
        const { html, nextReceipt } = responseItem;
        if (!html) return;
        const htmlString = isBase64(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);

        if (nextReceipt) {
            const nextReceiptString = isBase64(nextReceipt) ? atob(nextReceipt) : nextReceipt;
            this.insertAdjacentHTML('afterend', nextReceiptString);
        }
    }
}
